import React from 'react'

const backgrundOne = props => {
  return <div className='background' style={{ background: `url("${props.banner}")` }}>

  </div>
}

export default backgrundOne